import * as React from 'react'
import styled from 'styled-components'

import * as entities from '@boutique/entities'
import * as plume from '@ulule/owl-kit-components/next'

import * as bobUrl from '@bob/url'
import { PillarAccordion } from './PillarAccordion'

type RationaleProps = {
  product: entities.product.Product
  title: string
}

export function Rationale({ product, title }: RationaleProps): React.ReactElement {
  const environmentalPillars = product.criteria.environmental
  //'identifier' in product.brand, is used to verify if brand is SlimColdUnmatchedBrand
  const rationale = 'identifier' in product.brand ? product.brand?.rationale : null
  const socialPillars = product.criteria.social

  return (
    <Section>
      <plume.styles.heading.XS as="h3" asDesktop="L">
        {title}
      </plume.styles.heading.XS>
      {rationale && <plume.styles.copy.M as="p">{rationale}</plume.styles.copy.M>}
      <EngagementBlock as="div">
        <plume.logos.bob.BobLogo />
        <div>
          <div>La marque {product.brand.name} est engagée pour la planète et les humains&nbsp;!</div>
          {'identifier' in product.brand && (
            <plume.Link
              underlined
              href={
                bobUrl.brand({
                  slug: product.brand.slug,
                  name: product.brand.name,
                }).path
              }
              target="_blank"
            >
              Découvrir la marque sur Bien ou Bien
            </plume.Link>
          )}
          <PreLogoText>Elle fait partie du Guide Bien ou Bien, propulsé par</PreLogoText>
          <Logos>
            <LogoMaif alt="logo maif" src="/assets/images/maif-logo.png" /> et <plume.logos.ulule.OwlOnlyLogo />
          </Logos>
        </div>
      </EngagementBlock>
      {environmentalPillars.length > 0 && (
        <PillarAccordion
          criteria={environmentalPillars.map((criterion) => ({
            description: criterion.pillar.description,
            icon: criterion.pillar.icon,
            name: criterion.name,
            slug: criterion.slug,
          }))}
          pillar="Critères environnementaux"
          kind="environmentalPillar"
        />
      )}
      {socialPillars.length > 0 && (
        <PillarAccordion
          criteria={socialPillars.map((criterion) => ({
            description: criterion.pillar.description,
            icon: criterion.pillar.icon,
            name: criterion.name,
            slug: criterion.slug,
          }))}
          pillar="Critères sociaux"
          kind="socialPillar"
        />
      )}
    </Section>
  )
}

const EngagementBlock = styled(plume.styles.copy.S)`
  margin-bottom: 55px;
  text-align: center;

  ${plume.logos.ulule.OwlOnlyLogo} {
    height: 32px;
    width: 32px;
    display: inline;
    margin-left: 8px;
  }

  ${plume.Link} {
    display: block;
  }

  ${plume.logos.bob.BobLogo} {
    margin: 40px auto 10px;
    width: 85px;
    height: 48px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    display: flex;
    text-align: left;

    margin-top: 40px;

    ${plume.Link} {
      margin-top: 2px;
      margin-bottom: 14px;
    }

    ${plume.logos.bob.BobLogo} {
      margin: initial;
      width: 90px;
      margin-right: 20px;
      position: relative;
      top: 10px;
    }
  }
`

const PreLogoText = styled.div`
  max-width: 295px;
  margin: auto;
  margin-top: 25px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin: initial;
    display: inline;
  }
`

const Logos = styled.div`
  margin-top: 10px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-top: 0;
    display: inline;
  }
`

const LogoMaif = styled.img`
  display: inline;
  margin-right: 6px;
  width: 43px;
`

const Section = styled.section`
  border: 8px solid ${plume.COLORS.SECONDARY_GREEN_LIGHT};
  padding: 24px;
  margin-top: 40px;

  ${plume.styles.heading.XS} {
    margin-bottom: 8px;
  }

  @media screen and ${plume.BREAKPOINTS.MOBILE_L} {
    padding: 24px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 34px;
    margin-bottom: 40px;
    margin-top: 40px;

    ${plume.styles.heading.XS} {
      margin-bottom: 16px;
    }
  }
  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    padding-right: 40px;
    padding-left: 40px;
  }
  @media screen and ${plume.BREAKPOINTS.LAPTOP_L} {
  }
`
